import { Platform } from 'react-native';
import { NavigationContainer as NavContainer } from '@react-navigation/native';
import { navigationRef } from './RootNavigation';
import { setVisibilityAsync, setBehaviorAsync } from 'expo-navigation-bar';
import { PropsWithChildren } from 'react';
import { reactNavigationIntegrationForSentry } from '..';

// Wrapper for the native NavigationContainer from react-navigation that gets a children prop

const EXERCISE_ROUTES = [
  'AufgabenExercise',
  'AufgabenExerciseText',
  'BildKartenExercise',
];

const showNavigationBar = () => {
  setVisibilityAsync('visible');
};

const hideNavigationBar = () => {
  setVisibilityAsync('hidden');
  setBehaviorAsync('overlay-swipe');
};

export function NavigationContainer({ children }: PropsWithChildren) {
  return (
    <NavContainer
      onReady={() => {
        reactNavigationIntegrationForSentry.registerNavigationContainer(
          navigationRef,
        );
      }}
      onStateChange={(state) => {
        const notAndroid = Platform.OS !== 'android';
        if (notAndroid || !state) {
          return;
        }
        const { routes } = state;
        const activeRoute = routes[routes.length - 1];
        const isExercisePage = EXERCISE_ROUTES.includes(
          activeRoute?.name ?? '',
        );
        if (!isExercisePage) {
          return showNavigationBar();
        }
        hideNavigationBar();
      }}
      ref={navigationRef}
    >
      {children}
    </NavContainer>
  );
}
